import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, GlobeIcon } from 'lucide-react';
import { ContactForm } from './ContactForm';
import { Reveal } from './Reveal';
import { contact } from '../data/site';
export function Contact() {
  return <section id="contact" className="w-full bg-mist py-24 lg:py-32" data-id="element-40" data-mp="3173hx8kzhggq">
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10" data-id="element-41" data-mp="2w88q5h51ghkh">
        <div className="grid gap-14 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16" data-id="element-42" data-mp="2w9tlh8z6g4je">
          <div data-id="element-43" data-mp="3swy6h310p24c">
            <Reveal data-id="element-44" data-mp="3szke12nwrhmk">
              <p className="flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.24em] text-ice" data-id="element-45" data-mp="3oweba50088ku">
                <span className="h-px w-8 bg-ice" aria-hidden="true" data-id="element-46" data-mp="3k4wcnnlgek31" />
                Contact
              </p>
              <h2 className="mt-6 font-display text-3xl font-extrabold leading-[1.05] tracking-tightest text-ink sm:text-4xl lg:text-[3.1rem]" data-id="element-47" data-mp="3f59wp6e8qpqj">
                Let&apos;s Move Your Freight.
              </h2>
              <p className="mt-8 max-w-sm text-base leading-relaxed text-ink-soft" data-id="element-48" data-mp="bouel3k21f4g">
                Send us the lane, commodity, and temperature requirements. Dispatch responds with capacity and pricing.
              </p>
            </Reveal>

            <Reveal delay={0.05} data-id="element-49" data-mp="3owifinq51aj7">
              <dl className="mt-12 space-y-7 border-t border-line pt-8" data-id="element-50" data-mp="3b42l2bbayktw">
                <div data-id="element-51" data-mp="3f4uup5o36rqp">
                  <dt className="font-display text-lg font-bold uppercase tracking-tight text-ink" data-id="element-52" data-mp="3f42yptqkurzw">
                    Hold Fast Hauling
                  </dt>
                  <dd className="mt-1 text-sm text-ink-soft" data-id="element-53" data-mp="317g2jt6g85v1">Division of G&amp;D Property Solutions LLC</dd>
                </div>
                <div className="flex items-start gap-4" data-id="element-54" data-mp="2s4wzp92nxt8s">
                  <MapPinIcon className="mt-1 h-4 w-4 shrink-0 text-ice" aria-hidden="true" data-id="element-55" data-mp="2s6hvt34mlk8r" />
                  <div data-id="element-56" data-mp="2w6a6pmhhs2ha">
                    <dt className="text-[11px] font-bold uppercase tracking-[0.14em] text-ink-soft" data-id="element-57" data-mp="qd23m1sw3xbo">Headquarters</dt>
                    <dd className="mt-1.5 text-[15px] font-semibold text-ink" data-id="element-58" data-mp="uf5hsy6y1g0n">{contact.hq}</dd>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-59" data-mp="23d5bemoat893">
                  <PhoneIcon className="mt-1 h-4 w-4 shrink-0 text-ice" aria-hidden="true" data-id="element-60" data-mp="1ycr456uiu2c4" />
                  <div data-id="element-61" data-mp="1uam9q5w911of">
                    <dt className="text-[11px] font-bold uppercase tracking-[0.14em] text-ink-soft" data-id="element-62" data-mp="1ua48euuqbx9n">Phone</dt>
                    <dd className="mt-1.5" data-id="element-63" data-mp="1pd4ax8by42u5">
                      <a href={contact.phoneHref} className="text-[15px] font-semibold text-ink transition-colors duration-150 ease-premium hover:text-ice" data-id="element-64" data-mp="1pe5njh8m0xdz">
                        {contact.phone}
                      </a>
                    </dd>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-65" data-mp="289vmswp5rfo6">
                  <MailIcon className="mt-1 h-4 w-4 shrink-0 text-ice" aria-hidden="true" data-id="element-66" data-mp="35psvdm7zgwag" />
                  <div data-id="element-67" data-mp="30zm6dl9k79ro">
                    <dt className="text-[11px] font-bold uppercase tracking-[0.14em] text-ink-soft" data-id="element-68" data-mp="30z2kxukpa38w">Email</dt>
                    <dd className="mt-1.5" data-id="element-69" data-mp="38bilu28uju18">
                      <a href={`mailto:${contact.email}`} className="text-[15px] font-semibold text-ink transition-colors duration-150 ease-premium hover:text-ice" data-id="element-70" data-mp="38cttwe9brny5">
                        {contact.email}
                      </a>
                    </dd>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-71" data-mp="3r8tm9q67sti9">
                  <GlobeIcon className="mt-1 h-4 w-4 shrink-0 text-ice" aria-hidden="true" data-id="element-72" data-mp="2iezcam2wih" />
                  <div data-id="element-73" data-mp="4u0erx0wer1v">
                    <dt className="text-[11px] font-bold uppercase tracking-[0.14em] text-ink-soft" data-id="element-74" data-mp="4uthmmwqkweq">Service area</dt>
                    <dd className="mt-1.5 text-[15px] font-semibold text-ink" data-id="element-75" data-mp="9sbsiiubdlpd">Nationwide service — 48 states</dd>
                  </div>
                </div>
              </dl>
            </Reveal>
          </div>

          <Reveal delay={0.1} data-id="element-76" data-mp="itt35loycv6o">
            <ContactForm data-id="element-77" data-mp="56t0j9tq2wu6" />
          </Reveal>
        </div>
      </div>
    </section>;
}